import { forwardRef } from "react"
import { Chip as MuiChip } from "@mui/material"

import type { ChipProps } from "@mui/material/Chip"

const Chip = forwardRef<HTMLDivElement, ChipProps>(
  ({ label, onClick, sx, ...props }, ref) => {
    return (
      <MuiChip
        ref={ref}
        label={label}
        onClick={onClick}
        variant="outlined"
        size="small"
        title={label != null ? String(label) : ""}
        sx={{
          fontSize: "0.7rem",
          maxWidth: "150px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          ...sx,
        }}
        {...props}
      />
    )
  },
)

Chip.displayName = "Chip"

export default Chip
